import axios from 'axios';
import RestService from '../../../helpers/RestService';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';


export async function getReferals() {
  try {
    const {data} = await axios.get('/api/profile/referals');
    if(data.errcode == 200) {
      return {users: data.payload, user: data.user};
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Referals/actions.js